// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__copTx","header":"ReportDetails_header__uv1pC","title":"ReportDetails_title__1HkqM","left":"ReportDetails_left__1gKiu"};